export default __webpack_public_path__ + "static/media/before-after@3x.8f2d8502.png";